import { Label } from '@higgins/ui';

/**
 * A row of buttons for one choice on an area (Action, Delivery mode, Outlook
 * year): the chosen one filled, the suggested one dashed until something is
 * chosen. Tapping the chosen one again clears it.
 */
export function SuggestedChoice({
  label,
  options,
  chosen,
  suggested,
  onChoose,
}: {
  label: string;
  options: readonly string[];
  chosen: string | null;
  suggested: string | null;
  onChoose: (value: string | null) => void;
}) {
  return (
    <div>
      <Label>{label}</Label>
      <div className="mt-1 flex flex-wrap items-center gap-2">
        {options.map((o) => (
          <button
            key={o}
            type="button"
            aria-pressed={chosen === o}
            onClick={() => onChoose(chosen === o ? null : o)}
            className={`min-h-11 rounded-full border px-3 text-sm ${chosen === o ? 'border-primary bg-primary text-primary-foreground' : o === suggested && !chosen ? 'border-dashed border-primary text-orange-800' : 'border-slate-300 text-slate-700'}`}
          >
            {o}
          </button>
        ))}
        {!chosen && suggested && <span className="text-xs text-slate-500">Suggested from the rating: {suggested}. Tap to confirm.</span>}
      </div>
    </div>
  );
}
